import { UserProfile } from "../interfaces/user-profile";
import { Utils } from "../utils/utils";
import { MarketingClientConstants } from "../constants/marketing-client-constants";
import { DMParameters } from "../custom-types/custom-types";
import { DeviceInformationHelper } from "../helpers/device-information-helper";

export class UserData {
  profile: UserProfile = {
    url: "",
    tags: []
  };

  getProfile(): void {
    const urlParameters = Utils.getURLParamsAsObject(),
      refererParam = urlParameters[MarketingClientConstants.refererParam] as string,
      referrerParam = urlParameters[MarketingClientConstants.referrerParam] as string,
      os = DeviceInformationHelper.getOS() as string,
      device = DeviceInformationHelper.getDeviceType() as string;

    let dmData = Utils.getDMParams(),
      behavioralProfile = {};

    if (!Utils.isNullOrUndefined(dmData)) {
      dmData = dmData as DMParameters;

      try {
        const behavioralProfileString = dmData[MarketingClientConstants.dmBehavioralProfilesKey] as string;

        if (Utils.stringNotEmpty(behavioralProfileString)) {
          behavioralProfile = JSON.parse(behavioralProfileString);
        }
      } catch(e) {
        console.warn("Could not convert behavioral profile. Possibly empty or wrongly formatted");
      }

      Object.assign(this.profile, behavioralProfile);
      Object.assign(this.profile, dmData);

      delete this.profile[MarketingClientConstants.dmBehavioralProfilesKey];

      this.profile.url = window.location.href;
      this.profile.referer = refererParam || document.referrer;
      this.profile.referrer = referrerParam || document.referrer;
      this.profile.os = os;
      this.profile.device = device;
    }
  }
}
